import { render, staticRenderFns } from "./JBIContentCommon.vue?vue&type=template&id=54793f10&scoped=true&"
import script from "./JBIContentCommon.vue?vue&type=script&lang=ts&"
export * from "./JBIContentCommon.vue?vue&type=script&lang=ts&"
import style0 from "./JBIContentCommon.vue?vue&type=style&index=0&id=54793f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54793f10",
  null
  
)

export default component.exports